import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import IndustryReferences from '../../components/IndustryReferences';
import './Benefits.css';

const Benefits = () => { 
  useEffect(() => { 
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-visible');
        }
      });
    }, observerOptions);

    const fadeElements = document.querySelectorAll('.fade-in-section');
    fadeElements.forEach(el => observer.observe(el));

    return () => {
      fadeElements.forEach(el => observer.unobserve(el));
    };
  }, []);

  const benefits = [
    {
      id: 1,
      title: 'Global Market Reach',
      description: 'Expanding into new geographic markets can be challenging for independent freight forwarders. EFFN provides direct access to a global network of trusted logistics partners across key trade hubs. Members can enter new markets quickly without the need to build relationships from scratch. This enables faster expansion, reduced risk, and the ability to serve clients across international trade lanes with confidence.',
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <circle cx="12" cy="12" r="10"/>
          <path d="M2 12h20"/>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
        </svg>
      )
    },
    {
      id: 2,
      title: 'Professional Networking Events',
      description: 'EFFN hosts structured networking events, global conferences, and industry forums that bring logistics professionals together to build meaningful business relationships. Members gain opportunities to connect with trusted partners, explore new collaborations, and exchange operational insights. These engagements support informed decision-making, keep members aligned with market trends, and open pathways to new services and growth opportunities across the network.',
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      )
    },
    {
      id: 3,
      title: 'Financial Protection Plan',
      description: 'EFFN offers a structured financial protection program designed to minimize risk when working with network partners. Coverage is based on the selected membership plan. The program applies to freight charges and related logistics transactions, ensuring greater security in cross-border operations. This protection is limited to financial exposure and does not cover disputes related to service quality or delivery performance.',
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          <path d="M12 16v-4"/>
          <path d="M12 8h.01"/>
        </svg>
      )
    }
  ];

  return (
    <div className="benefits-page">
      {/* Hero Section */}
      <section className="benefits-hero fade-in-section">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Member Benefits – Expand Your Global Logistics Potential</h1>
            <p className="hero-subtitle">
              Discover the strategic advantages of joining a professional logistics network designed to support growth, strengthen partnerships, and deliver long-term business success.
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section fade-in-section">
        <div className="container">
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div 
                key={benefit.id} 
                className={`benefit-card hover-lift animate-fade-in-up animate-delay-${(index + 1) * 100}`}
              >
                <div className="benefit-icon-wrapper">
                  <div className="benefit-icon">
                    {benefit.icon}
                  </div>
                </div>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industry References Section */}
      {/* <IndustryReferences /> */}

      {/* CTA Section */}
      <section className="benefits-cta-section fade-in-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Become a Member Today</h2>
            <p className="cta-description">
              Join EFFN to connect with trusted logistics professionals, secure your transactions, and access exclusive business opportunities.
            </p>
            <Link to="/join-us" className="btn-cta-primary">
              Apply for Membership
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Benefits;
